import {
  PROJECT_ON_BOARD_CHANGE_PROJECT_STATUS_BEGIN,
  PROJECT_ON_BOARD_CHANGE_PROJECT_STATUS_SUCCESS,
  PROJECT_ON_BOARD_CHANGE_PROJECT_STATUS_FAILURE,
  PROJECT_ON_BOARD_CHANGE_PROJECT_STATUS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function changeProjectStatus(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PROJECT_ON_BOARD_CHANGE_PROJECT_STATUS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/project-on-board/change-status`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: PROJECT_ON_BOARD_CHANGE_PROJECT_STATUS_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: PROJECT_ON_BOARD_CHANGE_PROJECT_STATUS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissChangeProjectStatusError() {
  return {
    type: PROJECT_ON_BOARD_CHANGE_PROJECT_STATUS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROJECT_ON_BOARD_CHANGE_PROJECT_STATUS_BEGIN:
      return {
        ...state,
        changeProjectStatusPending: true,
        changeProjectStatusError: null,
      };

    case PROJECT_ON_BOARD_CHANGE_PROJECT_STATUS_SUCCESS:
      return {
        ...state,
        changeProjectStatusPending: false,
        changeProjectStatusError: null,
      };

    case PROJECT_ON_BOARD_CHANGE_PROJECT_STATUS_FAILURE:
      return {
        ...state,
        changeProjectStatusPending: false,
        changeProjectStatusError: action.data.error,
      };

    case PROJECT_ON_BOARD_CHANGE_PROJECT_STATUS_DISMISS_ERROR:
      return {
        ...state,
        changeProjectStatusError: null,
      };

    default:
      return state;
  }
}
